import { supabase } from '../../../lib/supabase'

const callAdminMembers = async (action, params = {}) => {
  const { data, error } = await supabase.functions.invoke('admin-members', {
    body: { action, ...params },
  })

  if (error) {
    // A non-2xx reply only carries a generic message; the function's own error is in the body
    let message = error.message
    try {
      const body = await error.context?.json()
      if (body?.error) message = body.error
    } catch {
      // Body wasn't JSON; keep the generic message
    }
    throw new Error(message)
  }

  if (data?.error) throw new Error(data.error)
  return data
}

export const listMembers = async () => (await callAdminMembers('list')).members

export const inviteMember = (email, role) =>
  callAdminMembers('invite', {
    email,
    role,
    redirect_to: `${window.location.origin}/set-password`,
  })

export const setMemberRole = (userId, role) => callAdminMembers('set_role', { user_id: userId, role })

export const disableMember = (userId) => callAdminMembers('disable', { user_id: userId })

export const enableMember = (userId) => callAdminMembers('enable', { user_id: userId })

export const revokeInvite = (userId) => callAdminMembers('revoke_invite', { user_id: userId })
